export default __webpack_public_path__ + "static/media/callEnd.849bd9e7.svg";